<template>
  <section class="section">
      <nav>
        <div class="tabs is-centered">
          <div class="ml-auto mr-auto">
            <ul v-if="currentUser.isAdmin" style="padding-left: 0;">
              <li :class="{'is-active': activeTab === 'latestReports'}"><a @click="showTab('latestReports')">Latest Reports</a></li>
              <li :class="{'is-active': activeTab === 'toolsUsage'}"><a @click="showTab('toolsUsage')">Stats</a></li>
            </ul>
          </div>
        </div>
      </nav>
      <div>
        <section v-if="activeTab === 'latestReports'" class="section pt15">
          <latest-reports/>
        </section>
        <section v-if="activeTab === 'toolsUsage'" class="section pt15">
          <tools-usage/>
        </section>
      </div>
  
  </section>
  </template>
  
  <script>
  import LatestReports from './LatestReports.vue'
  import ToolsUsage from './ToolsUsage.vue'
  
  export default {
    components: {
      LatestReports,
      ToolsUsage,
    },
    data () {
      return {
        activeTab: 'latestReports',
        ready: false
      }
    },
    methods: {
      showTab (tab) {
        this.activeTab = tab
      }
    },
    computed: {
      isLoading () {
        return this.$store.state.isLoading
      },
      currentUser() {
        if (this.$store.state.user) {
          return this.$store.state.user
        }
        return {}
      }
    },
    mounted () {
      
    }
  }
  </script>
  
  <style lang="scss">
  
  </style>